/*
 * Aurion — comportements des pages Aurion (layout/theme.liquid), sans framework ni dépendance.
 * Portage de ~/levant (composants React) : hero des quatre moments, récit « La nuit devient aube »
 * (GSAP et Lenis, chargés après l'événement load), simulateur, sélecteur de variante (fiche, bouton
 * d'achat flottant), galerie, panier AJAX (API du panier et rendu des sections), menu mobile, révélations au
 * défilement. Aucun texte produit ici : produit et variantes viennent de Shopify (aurion-donnees).
 * Données : <script id="aurion-donnees"> (snippets/aurion-donnees.liquid). Motion : DESIGN.md §5 ;
 * jetons lus sur :root, mouvement réduit respecté partout.
 */
(function () {
  'use strict';

  var racine = document.documentElement;
  var $ = function (selecteur, dans) { return (dans || document).querySelector(selecteur); };
  var $$ = function (selecteur, dans) { return Array.prototype.slice.call((dans || document).querySelectorAll(selecteur)); };

  /* ------------------------------------------------------------------------
     Motion : jetons de aurion.css, mouvement réduit (DESIGN.md §5)
     ------------------------------------------------------------------------ */

  function mouvementReduit() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function jeton(nom) {
    return getComputedStyle(racine).getPropertyValue(nom).trim();
  }

  /** Durée d'un jeton en millisecondes ; la feuille minifiée peut l'écrire en secondes (« .18s »). */
  function duree(nom) {
    var valeur = jeton(nom);
    var nombre = parseFloat(valeur);
    return /ms$/.test(valeur) ? nombre : nombre * 1000;
  }

  function echapper(texte) {
    return String(texte).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------------------
     Données de la page
     ------------------------------------------------------------------------ */

  var donnees = {};
  try {
    donnees = JSON.parse($('#aurion-donnees').textContent);
  } catch (e) {
    donnees = {};
  }
  var produit = donnees.produit || null;
  var routes = donnees.routes || { panier: '/cart', ajout: '/cart/add', modification: '/cart/change', racine: '/' };
  var articlesPanier = (donnees.panier && donnees.panier.articles) || 0;

  var ICONE_COCHE =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true" focusable="false" class="shrink-0 text-success"><path d="M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z"></path></svg>';
  var ICONE_INFO =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true" focusable="false" class="mt-0.5 shrink-0 text-error"><path d="M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"></path></svg>';

  /* ------------------------------------------------------------------------
     Variante choisie : pastilles de la fiche (champ id du formulaire), bouton d'achat flottant.
     Sur la fiche, ?variant= est rendu par Shopify (selected_or_first_available_variant) et
     tenu à jour ici ; ailleurs, le bouton flottant propose la variante par défaut du produit phare.
     ------------------------------------------------------------------------ */

  var varianteId = produit ? produit.varianteParDefaut : null;

  function variantePar(id) {
    if (!produit) return null;
    for (var i = 0; i < produit.variantes.length; i++) if (produit.variantes[i].id === id) return produit.variantes[i];
    return null;
  }

  function varianteCourante() {
    return variantePar(varianteId) || (produit && produit.variantes[0]) || null;
  }

  function estFicheDuProduit() {
    return Boolean(produit && $('[data-produit-section]'));
  }

  /** Répercute la variante courante partout où elle s'affiche. */
  function appliquerVariante() {
    var variante = varianteCourante();
    if (!variante) return;
    $$('[data-choix-variante]').forEach(function (entree) { entree.checked = Number(entree.value) === variante.id; });
    $$('[data-prix]').forEach(function (el) { el.textContent = variante.prix; });
    $$('[data-prix-court]').forEach(function (el) { el.textContent = variante.prixCourt; });
    $$('[data-variante-nom]').forEach(function (el) { el.textContent = variante.titre; });
    $$('[data-bouton-ajout]').forEach(function (bouton) {
      bouton.disabled = !variante.disponible;
      var libelle = $('span', bouton);
      if (libelle) libelle.textContent = variante.disponible ? bouton.dataset.libelle : bouton.dataset.libelleIndisponible;
    });
    /* Bouton flottant : il ajoute la variante affichée, son libellé suit la disponibilité. */
    $$('[data-variante-champ]').forEach(function (champ) { champ.value = variante.id; });
    $$('[data-bouton-flottant]').forEach(function (bouton) {
      bouton.disabled = !variante.disponible;
      var libelle = $('[data-libelle-flottant]', bouton);
      if (libelle) libelle.textContent = variante.disponible ? bouton.dataset.libelle : bouton.dataset.libelleIndisponible;
    });
    $$('[data-galerie]').forEach(function (galerie) {
      if (galerie.allerAuMedia && variante.media) galerie.allerAuMedia(variante.media);
    });
    if (estFicheDuProduit() && !produit.sansVariante && window.history.replaceState) {
      var adresse = new URL(window.location.href);
      adresse.searchParams.set('variant', variante.id);
      window.history.replaceState(window.history.state, '', adresse.toString());
    }
  }

  function choisirVariante(id) {
    if (!variantePar(id) || id === varianteId) return;
    varianteId = id;
    appliquerVariante();
  }

  /** Retour arrière : le navigateur a pu restaurer une autre pastille que celle du rendu initial. */
  function synchroniserVariante() {
    var cochee = $('[data-choix-variante]:checked');
    if (cochee && Number(cochee.value) !== varianteId) choisirVariante(Number(cochee.value));
  }

  /* ------------------------------------------------------------------------
     Panier : API AJAX de Shopify, puis rendu des sections (tiroir, page panier)
     ------------------------------------------------------------------------ */

  /** Pastille recréée à chaque changement : elle apparaît en grandissant (.pastille-panier, @starting-style). */
  function pastille(classes, valeur) {
    var span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    span.className = 'pastille-panier ' + classes;
    span.textContent = valeur;
    return span;
  }

  function majCompteur() {
    $$('[data-compte-panier]').forEach(function (conteneur) {
      conteneur.replaceChildren();
      if (articlesPanier > 0) {
        conteneur.append(
          pastille('grid h-6 min-w-6 place-items-center rounded-pill bg-cta px-1.5 text-xs font-medium text-on-cta tabular-nums', articlesPanier)
        );
      }
    });
    $$('[data-ouvrir-panier]').forEach(function (bouton) {
      bouton.setAttribute(
        'aria-label',
        articlesPanier > 0
          ? 'Ouvrir le panier, ' + articlesPanier + ' article' + (articlesPanier > 1 ? 's' : '')
          : 'Ouvrir le panier, vide'
      );
    });
  }

  function lireEtat(panier) {
    articlesPanier = panier.item_count;
    majCompteur();
  }

  function sectionsDuPanier() {
    return ['aurion-tiroir-panier'].concat(
      $$('[data-section-panier]').map(function (el) { return el.dataset.sectionPanier; })
    );
  }

  /** Remplace le contenu des sections rendues par Shopify, en gardant le focus sur le contrôle équivalent. */
  function appliquerSections(sections) {
    if (!sections) return;
    var actif = document.activeElement;
    var repere = null;
    if (actif && actif.closest) {
      var ligne = actif.closest('[data-ligne-panier]');
      if (ligne) {
        repere = {
          cle: ligne.dataset.lignePanier,
          pas: actif.getAttribute('data-quantite-pas'),
          retirer: actif.hasAttribute('data-retirer-ligne'),
        };
      }
    }
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'aurion-tiroir-panier') {
        var nouveau = $('[data-tiroir-contenu]', doc);
        var actuel = $('[data-tiroir-contenu]');
        if (nouveau && actuel) actuel.replaceWith(document.adoptNode(nouveau));
        afficherStatut();
      } else {
        var nouveauContenu = $('[data-panier-contenu]', doc);
        var hote = $('[data-section-panier="' + id + '"] [data-panier-contenu]');
        if (nouveauContenu && hote) hote.replaceWith(document.adoptNode(nouveauContenu));
      }
    });
    if (repere) {
      var cible = $('[data-ligne-panier="' + repere.cle + '"]');
      var focus = null;
      if (cible) {
        focus = repere.retirer
          ? $('[data-retirer-ligne]', cible)
          : $('[data-quantite-pas="' + repere.pas + '"]', cible);
        if (focus && focus.disabled) focus = $('[data-quantite-pas]:not([disabled])', cible);
      }
      if (!focus) focus = $('[data-tiroir] [data-fermer-panier]');
      if (focus && (!actif || !document.contains(actif))) focus.focus();
    }
  }

  var statut = null;

  function afficherStatut() {
    var hote = $('[data-tiroir-statut]');
    var tiroir = $('[data-tiroir]');
    if (!hote) return;
    hote.replaceChildren();
    if (!statut) {
      if (tiroir) tiroir.removeAttribute('aria-describedby');
      return;
    }
    var p = document.createElement('p');
    p.id = 'tiroir-statut';
    p.className = 'mx-5 flex items-center gap-3 rounded-md bg-surface px-4 py-3 md:mx-8';
    p.innerHTML = (statut.erreur ? ICONE_INFO : ICONE_COCHE) + '<span>' + echapper(statut.texte) + '</span>';
    hote.append(p);
    if (tiroir) tiroir.setAttribute('aria-describedby', 'tiroir-statut');
  }

  function ouvrirTiroir(nouveauStatut) {
    statut = nouveauStatut || null;
    afficherStatut();
    var tiroir = $('[data-tiroir]');
    if (tiroir && !tiroir.open) tiroir.showModal();
  }

  function fermerTiroir() {
    var tiroir = $('[data-tiroir]');
    if (tiroir && tiroir.open) tiroir.close();
  }

  function envoyer(url, corps) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    }).then(function (reponse) {
      return reponse.json().then(function (json) {
        if (!reponse.ok) throw json;
        return json;
      });
    });
  }

  function attente(bouton, actif) {
    if (!bouton) return;
    bouton.toggleAttribute('aria-busy', actif);
    var icone = $('[data-bouton-icone]', bouton);
    var roue = $('[data-bouton-attente]', bouton);
    if (icone && roue) {
      icone.classList.toggle('hidden', actif);
      roue.classList.toggle('hidden', !actif);
    }
  }

  function ajouter(varianteId, quantite, bouton) {
    var variante = variantePar(varianteId);
    attente(bouton, true);
    return envoyer(routes.ajout + '.js', {
      items: [{ id: varianteId, quantity: quantite }],
      sections: sectionsDuPanier().join(','),
      sections_url: window.location.pathname,
    })
      .then(function (reponse) {
        appliquerSections(reponse.sections);
        return fetch(routes.panier + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (panier) {
        lireEtat(panier);
        var nom = produit ? produit.titre : 'L’article';
        var texte = variante && !produit.sansVariante
          ? nom + ' (' + variante.titre + ') a été ajouté à votre panier.'
          : nom + ' a été ajouté à votre panier.';
        ouvrirTiroir({ texte: texte });
      })
      .catch(function (erreur) {
        ouvrirTiroir({
          erreur: true,
          texte: (erreur && (erreur.description || erreur.message)) || 'L’ajout au panier n’a pas abouti. Réessayez dans un instant.',
        });
      })
      .then(function () { attente(bouton, false); });
  }

  function modifierLigne(cle, quantite) {
    return envoyer(routes.modification + '.js', {
      id: cle,
      quantity: quantite,
      sections: sectionsDuPanier().join(','),
      sections_url: window.location.pathname,
    })
      .then(function (panier) {
        appliquerSections(panier.sections);
        lireEtat(panier);
      })
      .catch(function (erreur) {
        statut = {
          erreur: true,
          texte: (erreur && erreur.description) || 'La modification du panier n’a pas abouti. Réessayez dans un instant.',
        };
        afficherStatut();
      });
  }

  /** La ligne s'efface en se repliant, en un seul mouvement, avant d'être retirée (DESIGN.md §5). */
  function retirerLigne(ligne, cle) {
    if (!ligne || mouvementReduit() || !ligne.animate) {
      modifierLigne(cle, 0);
      return;
    }
    if (ligne.inert) return;
    ligne.inert = true;
    ligne.style.overflow = 'hidden';
    var style = getComputedStyle(ligne);
    ligne
      .animate(
        [
          { opacity: 1, height: ligne.offsetHeight + 'px', paddingTop: style.paddingTop, paddingBottom: style.paddingBottom },
          { opacity: 0, height: '0px', paddingTop: '0px', paddingBottom: '0px' },
        ],
        { duration: duree('--dur-exit'), easing: jeton('--ease-out'), fill: 'forwards' }
      )
      .finished.catch(function () {})
      .then(function () { modifierLigne(cle, 0); });
  }

  /* Sélecteur de quantité : − valeur + */
  function majQuantite(groupe, valeur) {
    var min = Number(groupe.dataset.min || 1);
    var max = Number(groupe.dataset.max || 10);
    valeur = Math.min(Math.max(valeur, min), max);
    $('[data-quantite-valeur]', groupe).textContent = valeur;
    $('[data-quantite-pas="-1"]', groupe).disabled = valeur <= min;
    $('[data-quantite-pas="1"]', groupe).disabled = valeur >= max;
    return valeur;
  }

  /* ------------------------------------------------------------------------
     Délégation des clics et changements (sections rendues à nouveau comprises)
     ------------------------------------------------------------------------ */

  document.addEventListener('click', function (evenement) {
    var cible = evenement.target.closest && evenement.target;
    if (!cible) return;

    var ouvrir = cible.closest('[data-ouvrir-panier]');
    if (ouvrir && $('[data-tiroir]')) {
      evenement.preventDefault();
      ouvrirTiroir(null);
      return;
    }
    if (cible.closest('[data-fermer-panier]')) {
      fermerTiroir();
      return;
    }
    var tiroir = cible.closest('[data-tiroir]');
    if (tiroir && evenement.target === tiroir) {
      fermerTiroir();
      return;
    }

    if (cible.closest('[data-ouvrir-menu]')) {
      var menu = $('[data-menu-mobile]');
      if (menu && !menu.open) menu.showModal();
      return;
    }
    if (cible.closest('[data-fermer-menu]')) {
      var menuOuvert = $('[data-menu-mobile]');
      if (menuOuvert && menuOuvert.open) menuOuvert.close();
      return;
    }

    var pas = cible.closest('[data-quantite-pas]');
    if (pas) {
      var groupe = pas.closest('[data-quantite]');
      var actuelle = Number($('[data-quantite-valeur]', groupe).textContent);
      var suivante = majQuantite(groupe, actuelle + Number(pas.dataset.quantitePas));
      if (groupe.hasAttribute('data-ligne-cle')) {
        if (suivante !== actuelle) modifierLigne(groupe.dataset.ligneCle, suivante);
      } else {
        var formulaire = groupe.closest('form');
        var champ = formulaire && $('[data-quantite-champ]', formulaire);
        if (champ) champ.value = suivante;
      }
      return;
    }

    var retirer = cible.closest('[data-retirer-ligne]');
    if (retirer) {
      retirerLigne(retirer.closest('[data-ligne-panier]'), retirer.dataset.retirerLigne);
      return;
    }
  });

  document.addEventListener('change', function (evenement) {
    var entree = evenement.target;
    if (entree.matches && entree.matches('[data-choix-variante]')) {
      choisirVariante(Number(entree.value));
    }
  });

  document.addEventListener('submit', function (evenement) {
    var formulaire = evenement.target;
    if (!formulaire.matches('[data-formulaire-produit]')) return;
    evenement.preventDefault();
    var id = Number(new FormData(formulaire).get('id'));
    var champ = $('[data-quantite-champ]', formulaire);
    var quantite = Number(champ ? champ.value : 1);
    /* Bouton d'ajout de la fiche ; « Acheter » de l'en-tête et bouton flottant : le bouton qui a envoyé le formulaire. */
    ajouter(id, quantite, $('[data-bouton-ajout]', formulaire) || evenement.submitter).then(function () {
      if (champ) champ.value = 1;
      var groupe = $('[data-quantite-achat]', formulaire);
      if (groupe) majQuantite(groupe, 1);
    });
  });

  /* Retour arrière (cache de navigation) : le panier a pu changer entre-temps. */
  window.addEventListener('pageshow', function (evenement) {
    if (!evenement.persisted) return;
    fetch(routes.panier + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(lireEtat)
      .catch(function () {});
  });

  /* ------------------------------------------------------------------------
     En-tête : [data-defile] dès que la page a défilé (fond translucide, flou, ombre ; src/aurion.css)
     ------------------------------------------------------------------------ */

  function initEnTete() {
    var enTete = $('[data-en-tete]');
    if (!enTete) return;
    var defile = null;
    var maj = function () {
      var etat = window.scrollY > 8;
      if (etat === defile) return;
      defile = etat;
      enTete.toggleAttribute('data-defile', etat);
    };
    window.addEventListener('scroll', maj, { passive: true });
    maj();
  }

  /* ------------------------------------------------------------------------
     Révélations au défilement (DESIGN.md §5) : [data-reveal] reçoit [data-visible]
     ------------------------------------------------------------------------ */

  var observateurRevelations = null;

  function initRevelations(dans) {
    var elements = $$('[data-reveal]:not([data-visible])', dans);
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.setAttribute('data-visible', ''); });
      return;
    }
    observateurRevelations =
      observateurRevelations ||
      new IntersectionObserver(
        function (entrees, observateur) {
          entrees.forEach(function (entree) {
            if (!entree.isIntersecting) return;
            entree.target.setAttribute('data-visible', '');
            observateur.unobserve(entree.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    elements.forEach(function (el) { observateurRevelations.observe(el); });
  }

  /* ------------------------------------------------------------------------
     Hero « Les quatre moments » (~/levant/components/accueil/Hero.tsx)
     ------------------------------------------------------------------------ */

  function initMoments(section) {
    var moments;
    try {
      moments = JSON.parse($('[data-moments-donnees]', section).textContent);
    } catch (e) {
      return;
    }
    var total = moments.length;
    if (total < 2) return;
    var scene = $('.moments-scene', section);
    var texte = $('[data-moments-texte]', section);
    var fantomes = $$('.moments-fantome', scene);
    var gabarit = $('template[data-moments-differes]', section);
    var actif = 0;
    var verrou = false;
    var tousMontes = !gabarit;

    function role(i) {
      var ecart = (i - actif + total) % total;
      if (ecart === 0) return 'centre';
      if (ecart === 1) return 'droite';
      if (ecart === total - 1) return 'gauche';
      return 'arriere';
    }

    /* Visuel central seul exposé aux technologies d'assistance : alt d'une photo, libellé d'une illustration SVG. */
    function placer() {
      $$('[data-moment-image]', scene).forEach(function (image) {
        var i = Number(image.dataset.momentImage);
        var r = role(i);
        var photo = image.tagName === 'IMG';
        image.dataset.role = r;
        if (r === 'centre') {
          if (photo) image.alt = moments[i].alt;
          else {
            image.setAttribute('role', 'img');
            image.setAttribute('aria-label', moments[i].alt);
          }
          image.removeAttribute('aria-hidden');
        } else {
          if (photo) image.alt = '';
          else {
            image.removeAttribute('role');
            image.removeAttribute('aria-label');
          }
          image.setAttribute('aria-hidden', 'true');
        }
      });
      fantomes.forEach(function (fantome, i) { fantome.toggleAttribute('data-actif', i === actif); });
      section.dataset.moment = moments[actif].moment;
    }

    /* Les photos des autres moments ne se montent qu'après la photo centrale (élément LCP). */
    function monterTout() {
      if (tousMontes) return;
      tousMontes = true;
      scene.append(gabarit.content.cloneNode(true));
      placer();
    }
    var central = $('[data-moment-image="0"]', scene);
    if (!central || central.tagName !== 'IMG' || central.complete) monterTout();
    else {
      central.addEventListener('load', monterTout, { once: true });
      central.addEventListener('error', monterTout, { once: true });
    }

    function ecrireTexte() {
      var m = moments[actif];
      var bloc = document.createElement('div');
      bloc.className = 'moments-texte';
      bloc.innerHTML =
        '<p class="t-h3">' + echapper(m.nom) +
        '<span class="sr-only">, moment ' + (actif + 1) + ' sur ' + total + '</span></p>' +
        '<p class="t-body mt-1.5 lg:mt-2 lg:t-body-l">' + echapper(m.phrase) + '</p>';
      texte.replaceChildren(bloc);
    }

    function aller(sens) {
      if (verrou) return;
      verrou = true;
      window.setTimeout(function () { verrou = false; }, duree('--dur-moment'));
      section.dataset.aChange = '';
      monterTout();
      actif = (actif + sens + total) % total;
      placer();
      ecrireTexte();
    }

    $$('[data-moments-pas]', section).forEach(function (bouton) {
      bouton.addEventListener('click', function () { aller(Number(bouton.dataset.momentsPas)); });
    });

    /* Flèches du clavier, tant que le hero est à l'écran et que la touche ne sert pas à un champ ou un dialogue. */
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) { visible = entrees[0].isIntersecting; }, { threshold: 0.5 }).observe(section);
    }
    window.addEventListener('keydown', function (evenement) {
      if (evenement.key !== 'ArrowLeft' && evenement.key !== 'ArrowRight') return;
      if (!visible || evenement.defaultPrevented || evenement.altKey || evenement.ctrlKey || evenement.metaKey) return;
      if (evenement.target.closest && evenement.target.closest('input, textarea, select, [contenteditable], dialog, [data-galerie]')) return;
      if (!document.contains(section)) return;
      evenement.preventDefault();
      aller(evenement.key === 'ArrowRight' ? 1 : -1);
    });

    /* Balayage tactile : 40 px, horizontal dominant. */
    var toucher = null;
    section.addEventListener('touchstart', function (evenement) {
      var t = evenement.touches[0];
      toucher = { x: t.clientX, y: t.clientY };
    }, { passive: true });
    section.addEventListener('touchend', function (evenement) {
      var debut = toucher;
      toucher = null;
      if (!debut) return;
      var t = evenement.changedTouches[0];
      var dx = t.clientX - debut.x;
      var dy = t.clientY - debut.y;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      aller(dx < 0 ? 1 : -1);
    });
  }

  /* ------------------------------------------------------------------------
     Heures et durées (mêmes formats que snippets/aurion-heure.liquid)
     ------------------------------------------------------------------------ */

  function deuxChiffres(n) {
    return (n < 10 ? '0' : '') + n;
  }
  /* Espaces insécables : « 6 h 30 » ne se coupe jamais. */
  function formatHeure(minutes) {
    return Math.floor(minutes / 60) + '\u00a0h\u00a0' + deuxChiffres(minutes % 60);
  }
  function formatHorloge(minutes) {
    return deuxChiffres(Math.floor(minutes / 60)) + ':' + deuxChiffres(minutes % 60);
  }
  /** Heure de l'afficheur d'une illustration (snippets/aurion-produit.liquid) : un chiffre à sept segments par <use>. */
  function ecrireAfficheur(afficheur, libelle) {
    if (afficheur.dataset.afficheur === libelle) return;
    afficheur.dataset.afficheur = libelle;
    var chiffres = libelle.replace(':', '').split('');
    $$('[data-chiffre]', afficheur).forEach(function (chiffre, i) {
      var c = chiffres[i] === '-' ? 'tiret' : chiffres[i];
      chiffre.setAttribute('href', '#aurion-c-' + c);
    });
  }
  function formatDuree(minutes) {
    var h = Math.floor(minutes / 60);
    return h > 0 ? h + '\u00a0h\u00a0' + deuxChiffres(minutes % 60) : (minutes % 60) + '\u00a0min';
  }

  /* Lever du soleil : portage du calcul de suncalc 2 (BSD-2, V. Agafonkin ; Jean Meeus, ch. 15 et 25),
     celui de scripts/villes.mjs. Jours depuis J2000 (TU) ; positions en temps terrestre (ΔT). */
  var RAD = Math.PI / 180;
  var TOUR = 2 * Math.PI;

  function tempsTerrestre(d) {
    var t = d / 365.2425; /* années depuis 2000, ΔT d'Espenak et Meeus, 2005–2050 */
    return d + (62.92 + t * (0.32217 + t * 0.005589)) / 86400;
  }
  function soleil(d) {
    var t = d / 36525;
    var L0 = RAD * (280.46646 + t * (36000.76983 + t * 0.0003032));
    var M = RAD * (357.52911 + t * (35999.05029 - t * 0.0001537));
    var sinM = Math.sin(M);
    var C = RAD * ((1.914602 - t * (0.004817 + t * 0.000014)) * sinM +
      (0.019993 - 0.000101 * t) * 2 * sinM * Math.cos(M) + 0.000289 * sinM * (3 - 4 * sinM * sinM));
    var Om = RAD * (125.04 - 1934.136 * t);
    var L = L0 + C - RAD * (0.00569 + 0.00478 * Math.sin(Om));
    var e = RAD * (23.439291 - t * (0.0130042 + t * (0.00000016 - t * 0.000000504))) + RAD * 0.00256 * Math.cos(Om);
    return { ra: Math.atan2(Math.cos(e) * Math.sin(L), Math.cos(L)), dec: Math.asin(Math.sin(e) * Math.sin(L)) };
  }
  function angleHoraire(d, lw) {
    var H = RAD * (280.46061837 + 360.98564736629 * d) - lw - soleil(tempsTerrestre(d)).ra;
    return H - TOUR * Math.round(H / TOUR);
  }
  /** Lever du soleil, en ms TU, le jour civil donné (année, mois de 0 à 11, jour) à la latitude et longitude données. */
  function leverDuSoleil(annee, mois, jour, lat, lon) {
    var J0 = 0.0009;
    var lw = -lon * RAD;
    var phi = lat * RAD;
    var h0 = -0.833 * RAD;
    var dt = Math.round(Date.UTC(annee, mois, jour, 12) / 86400000 - 10957.5 - J0 - lw / TOUR) + J0 + lw / TOUR;
    for (var i = 0; i < 3; i++) dt -= angleHoraire(dt, lw) / TOUR;
    var dec = soleil(tempsTerrestre(dt)).dec;
    var d = dt - Math.acos((Math.sin(h0) - Math.sin(phi) * Math.sin(dec)) / (Math.cos(phi) * Math.cos(dec))) / TOUR;
    for (var j = 0; j < 2; j++) {
      var c = soleil(tempsTerrestre(d));
      var H = angleHoraire(d, lw);
      var h = Math.asin(Math.sin(phi) * Math.sin(c.dec) + Math.cos(phi) * Math.cos(c.dec) * Math.cos(H));
      var sinH = Math.cos(phi) * Math.cos(c.dec) * Math.sin(H);
      if (Math.abs(sinH) < 1e-6) break;
      d += (h - h0) / (TOUR * sinH);
    }
    return (d + 10957.5) * 86400000;
  }

  /** Heure légale française (minutes depuis minuit) d'un instant en ms TU : les villes du simulateur sont en France. */
  var heureDeParis = null;
  try {
    heureDeParis = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  } catch (e) {
    heureDeParis = null;
  }
  function minutesDeParis(ms) {
    var parties = heureDeParis.formatToParts(new Date(Math.round(ms / 60000) * 60000));
    var valeur = function (type) {
      for (var i = 0; i < parties.length; i++) if (parties[i].type === type) return Number(parties[i].value);
      return 0;
    };
    return valeur('hour') * 60 + valeur('minute');
  }

  /* ------------------------------------------------------------------------
     Simulateur « Votre hiver dans le noir » (~/levant/components/accueil/Simulateur.tsx) : lever du soleil
     à la date du jour du visiteur (ou au 21 décembre, à sa demande), pour sa ville et son heure de réveil.
     ------------------------------------------------------------------------ */

  function initSimulateur(simu) {
    var REVEIL = { min: 300, max: 540, pas: 15 };
    var FRISE = { debut: 300, fin: 600 };
    var LECTURE_MS = 6000;
    var COMPTE_MS = 700;

    var choixVille = $('[data-simu-ville]', simu);
    var sortieReveil = $('[data-simu-reveil]', simu);
    var noirEl = $('[data-simu-noir]', simu);
    var sceneEl = $('[data-simu-scene]', simu);
    var curseur = $('[data-simu-curseur]', simu);
    var boutonLecture = $('[data-simu-lecture]', simu);
    var objets = $$('[data-simu-objet]', simu);

    var phraseEl = $('[data-simu-phrase]', simu);
    var boutonDate = $('[data-simu-date]', simu);
    var etats = (simu.dataset.etats || '').split('|').map(function (e) { return e.trim(); });
    var hiver = false; /* false : date du jour ; true : 21 décembre */
    var reveil = Number(sortieReveil.dataset.valeur);
    var noirAffiche = Number(noirEl.dataset.valeur);
    var t = 0;
    var lecture = false;
    var image = 0;
    var compte = 0;

    /* Lever calculé dans le navigateur pour la date voulue ; sans fuseau horaire connu, celui de la page (jour de la boutique). */
    function ville() {
      var option = choixVille.options[choixVille.selectedIndex];
      var lever = Number(option.dataset.lever);
      var lat = Number(option.dataset.lat);
      var lon = Number(option.dataset.lon);
      if (heureDeParis && !isNaN(lat) && !isNaN(lon)) {
        var aujourdhui = new Date();
        var calcul = hiver
          ? leverDuSoleil(aujourdhui.getFullYear(), 11, 21, lat, lon)
          : leverDuSoleil(aujourdhui.getFullYear(), aujourdhui.getMonth(), aujourdhui.getDate(), lat, lon);
        if (!isNaN(calcul)) lever = minutesDeParis(calcul);
      }
      return { nom: option.value, lever: lever };
    }
    function dureeAube() {
      var choisie = $('[data-simu-duree]:checked', simu);
      return Number(choisie ? choisie.value : 30);
    }
    function position(minutes) {
      return ((minutes - FRISE.debut) / (FRISE.fin - FRISE.debut)) * 100;
    }
    function lisse(a, b, x) {
      var v = Math.min(Math.max((x - a) / (b - a), 0), 1);
      return v * v * (3 - 2 * v);
    }
    /* Libellés : réglage « États de la lumière » de la section, cinq états séparés par |. */
    function phase(x) {
      var i = x <= 0 ? 0 : x < 0.34 ? 1 : x < 0.8 ? 2 : x < 1 ? 3 : 4;
      return { id: i < 2 ? 'nuit' : i < 3 ? 'aube' : 'reveil', libelle: etats[i] || '' };
    }

    /* Le temps dans le noir glisse vers sa nouvelle valeur (ease-out cubique), repris d'où il en est. */
    function compter(cible, immediat) {
      cancelAnimationFrame(compte);
      var de = noirAffiche;
      if (de === cible) return;
      var total = immediat || mouvementReduit() ? 0 : COMPTE_MS;
      var debut = performance.now();
      var pas = function (maintenant) {
        var p = total ? Math.min((maintenant - debut) / total, 1) : 1;
        noirAffiche = de + (cible - de) * (1 - Math.pow(1 - p, 3));
        noirEl.textContent = formatDuree(Math.round(noirAffiche));
        if (p < 1) compte = requestAnimationFrame(pas);
        else noirAffiche = cible;
      };
      compte = requestAnimationFrame(pas);
    }

    function rendreConstat(immediat) {
      var v = ville();
      var noir = Math.max(0, v.lever - reveil);
      var date = hiver ? simu.dataset.dateHiver : simu.dataset.dateJour;
      compter(noir, immediat);
      sortieReveil.textContent = formatHeure(reveil);
      $('[data-simu-pas="-1"]', simu).disabled = reveil <= REVEIL.min;
      $('[data-simu-pas="1"]', simu).disabled = reveil >= REVEIL.max;
      phraseEl.textContent = (noir > 0 ? phraseEl.dataset.modeleNoir : phraseEl.dataset.modeleJour)
        .replace('{ville}', v.nom)
        .replace('{lever}', formatHeure(v.lever))
        .replace('{date}', date);
      /* Soleil déjà levé à l'heure du réveil : proposer le 21 décembre ; au 21 décembre : revenir à aujourd'hui. */
      if (boutonDate) {
        var cache = !hiver && noir > 0;
        if (cache && document.activeElement === boutonDate) phraseEl.focus();
        boutonDate.hidden = cache;
        $('span', boutonDate).textContent = hiver ? boutonDate.dataset.libelleJour : boutonDate.dataset.libelleHiver;
      }
      $('[data-simu-annonce]', simu).textContent =
        v.nom + ', réveil à ' + formatHeure(reveil) + ' : ' + formatDuree(noir) + ' dans le noir ' + date + ', lever du soleil à ' + formatHeure(v.lever) + '.';
      $('[data-simu-jour]', simu).style.setProperty('--debut', position(v.lever) + '%');
      $('[data-simu-repere="reveil"]', simu).style.setProperty('--x', position(reveil) + '%');
      $('[data-simu-repere="lever"]', simu).style.setProperty('--x', position(v.lever) + '%');
      $('[data-simu-texte="reveil"]', simu).textContent = formatHeure(reveil);
      $('[data-simu-texte="lever"]', simu).textContent = formatHeure(v.lever);
    }

    function rendreScene() {
      var d = dureeAube();
      var debutAube = reveil - d;
      var minute = Math.round(debutAube + d * t);
      var etat = phase(t);
      sceneEl.dataset.phase = etat.id;
      $('[data-simu-fantome]', simu).textContent = etat.id === 'nuit' ? 'NUIT' : etat.id === 'aube' ? 'AUBE' : 'RÉVEIL';
      var opacites = [1, lisse(0.12, 0.5, t), lisse(0.55, 0.92, t)];
      objets.forEach(function (objet, i) { objet.style.opacity = opacites[i]; });
      $$('[data-afficheur]', sceneEl).forEach(function (el) { ecrireAfficheur(el, formatHorloge(minute)); });
      $('[data-simu-debut]', simu).textContent = formatHeure(debutAube);
      $('[data-simu-minute]', simu).textContent = formatHeure(minute);
      $('[data-simu-etat]', simu).textContent = etat.libelle;
      curseur.value = Math.round(t * 100);
      curseur.setAttribute('aria-valuetext', etat.libelle ? formatHeure(minute) + ', ' + etat.libelle : formatHeure(minute));
      curseur.style.setProperty('--remplissage', t * 100 + '%');
      boutonLecture.setAttribute('aria-label', lecture ? 'Mettre en pause' : t >= 1 ? 'Revoir l’aube' : 'Voir l’aube');
      $('[data-simu-icone="lecture"]', boutonLecture).classList.toggle('hidden', lecture);
      $('[data-simu-icone="pause"]', boutonLecture).classList.toggle('hidden', !lecture);
    }

    function arreter() {
      cancelAnimationFrame(image);
      lecture = false;
      rendreScene();
    }

    function lancer() {
      if (mouvementReduit()) {
        t = 1;
        rendreScene();
        return;
      }
      var depart = t >= 1 ? 0 : t;
      var total = LECTURE_MS * (1 - depart);
      var debut = performance.now();
      lecture = true;
      var pas = function (maintenant) {
        var p = Math.min((maintenant - debut) / total, 1);
        t = depart + (1 - depart) * p;
        if (p >= 1) lecture = false;
        rendreScene();
        if (p < 1) image = requestAnimationFrame(pas);
      };
      image = requestAnimationFrame(pas);
    }

    choixVille.addEventListener('change', function () { rendreConstat(); });
    if (boutonDate) {
      boutonDate.addEventListener('click', function () {
        hiver = !hiver;
        rendreConstat();
      });
    }
    $$('[data-simu-pas]', simu).forEach(function (bouton) {
      bouton.addEventListener('click', function () {
        reveil = Math.min(Math.max(reveil + Number(bouton.dataset.simuPas) * REVEIL.pas, REVEIL.min), REVEIL.max);
        rendreConstat();
        rendreScene();
      });
    });
    $$('[data-simu-duree]', simu).forEach(function (entree) { entree.addEventListener('change', rendreScene); });
    boutonLecture.addEventListener('click', function () {
      if (lecture) arreter();
      else lancer();
    });
    curseur.addEventListener('input', function () {
      cancelAnimationFrame(image);
      lecture = false;
      t = Number(curseur.value) / 100;
      rendreScene();
    });
    /* Lever recalculé à la date du visiteur (la page est rendue au jour de la boutique) ; le navigateur a aussi
       pu restaurer une autre ville que celle du rendu initial (retour arrière). */
    rendreConstat(true);
  }

  /* ------------------------------------------------------------------------
     Galerie produit (~/levant/components/produit/Galerie.tsx) : vignettes, flèches, clavier
     ------------------------------------------------------------------------ */

  function initGalerie(galerie) {
    var vues = $$('[data-galerie-vue]', galerie);
    var vignettes = $$('[data-galerie-vignette]', galerie);
    var coeur = $('[data-galerie-coeur]', galerie);
    var total = vues.length;
    var index = 0;
    if (!total) return;

    function aller(cible) {
      index = (cible + total) % total;
      vues.forEach(function (vue, i) {
        var active = i === index;
        vue.classList.toggle('opacity-100', active);
        vue.classList.toggle('opacity-0', !active);
        vue.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      vignettes.forEach(function (vignette, i) {
        if (i === index) vignette.setAttribute('aria-current', 'true');
        else vignette.removeAttribute('aria-current');
      });
      if (coeur) coeur.toggleAttribute('data-sombre', vues[index].hasAttribute('data-sombre'));
      $('[data-galerie-index]', galerie).textContent = index + 1;
      $('[data-galerie-annonce]', galerie).textContent = 'Vue ' + (index + 1) + ' sur ' + total + ' : ' + vues[index].dataset.libelle;
    }

    galerie.allerAuMedia = function (media) {
      for (var i = 0; i < vues.length; i++) if (Number(vues[i].dataset.media) === media) return aller(i);
    };

    $$('[data-galerie-pas]', galerie).forEach(function (bouton) {
      bouton.addEventListener('click', function () { aller(index + Number(bouton.dataset.galeriePas)); });
    });
    vignettes.forEach(function (vignette) {
      vignette.addEventListener('click', function () { aller(Number(vignette.dataset.galerieVignette)); });
    });
    galerie.addEventListener('keydown', function (evenement) {
      var actions = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: total - 1 };
      if (!(evenement.key in actions)) return;
      evenement.preventDefault();
      aller(actions[evenement.key]);
    });
  }

  /* ------------------------------------------------------------------------
     Récit « La nuit devient aube » et dérive des chiffres géants (~/levant/lib/scenes-accueil.ts).
     GSAP, ScrollTrigger et Lenis (assets/aurion-*.min.js) sont chargés après l'événement load, au
     premier temps libre, jamais en mouvement réduit : ils ne disputent rien au visuel du hero (LCP).
     ------------------------------------------------------------------------ */

  var moteur = null;
  var arreterScenes = null;

  function script(src) {
    return new Promise(function (resolve, reject) {
      var balise = document.createElement('script');
      balise.src = src;
      balise.async = false; /* exécutés dans l'ordre d'insertion : ScrollTrigger lit window.gsap */
      balise.onload = function () { resolve(); };
      balise.onerror = reject;
      document.head.append(balise);
    });
  }

  function chargerMoteur() {
    moteur = moteur || Promise.all((donnees.moteur || []).map(script));
    return moteur;
  }

  function lancerScenes() {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var Lenis = window.Lenis;
    if (!gsap || !ScrollTrigger) return function () {};
    gsap.registerPlugin(ScrollTrigger);
    var mm = gsap.matchMedia();

    mm.add('(prefers-reduced-motion: no-preference)', function () {
      /* autoToggle : Lenis s'arrête quand <html> passe en overflow hidden (dialogue ouvert). */
      var lenis = Lenis ? new Lenis({ autoToggle: true, stopInertiaOnNavigate: true }) : null;
      var battement = function (temps) { if (lenis) lenis.raf(temps * 1000); };
      if (lenis) {
        lenis.on('scroll', ScrollTrigger.update);
        gsap.ticker.add(battement);
        gsap.ticker.lagSmoothing(0);
      }

      /* La scène ne s'active que si le récit est encore sous la ligne de flottaison : sinon (retour
         arrière, défilement rapide avant le chargement), les bandes fixes restent pour cette visite. */
      var recit = document.getElementById('recit');
      if (recit && recit.getBoundingClientRect().top >= window.innerHeight - 1) {
        recit.dataset.anime = '';
        scenerRecit(gsap, recit);
      }
      $$('[data-derive]').forEach(function (element) { deriver(gsap, element); });

      /* Les sections en content-visibility: auto ne prennent leur vraie hauteur qu'au rendu :
         les positions de déclenchement sont recalculées quand la page change de hauteur. */
      var attenteRafraichir = 0;
      var observateur = new ResizeObserver(function () {
        window.clearTimeout(attenteRafraichir);
        attenteRafraichir = window.setTimeout(function () { ScrollTrigger.refresh(); }, 150);
      });
      observateur.observe(document.body);

      return function () {
        if (recit) delete recit.dataset.anime;
        observateur.disconnect();
        window.clearTimeout(attenteRafraichir);
        if (lenis) {
          gsap.ticker.remove(battement);
          gsap.ticker.lagSmoothing(500, 33);
          lenis.destroy();
        }
      };
    });

    return function () { mm.revert(); };
  }

  /** Valeur d'une couleur primitive de aurion.css (GSAP n'interpole pas var()). */
  function couleur(nom) {
    return jeton(nom);
  }

  /**
   * Récit « La nuit devient aube » (DESIGN.md §7.2), sur la course de la scène collante.
   * Chaque texte n'est lisible que sur les fonds qui lui garantissent AA (§2) ; l'horloge
   * (grand texte, 3:1) passe de l'abricot au lin, puis à l'encre quand le ciel du matin s'éclaircit.
   */
  function scenerRecit(gsap, section) {
    var q = gsap.utils.selector(section);
    var ciel = function (nom) { return q('[data-ciel="' + nom + '"]'); };
    var objet = function (id) { return q('[data-etape="' + id + '"] .recit-objet'); };
    var texte = function (id) { return q('[data-etape="' + id + '"] .recit-texte'); };
    var horloge = q('.recit-horloge');
    var avancerHorloge = horlogeARouleaux(gsap, section);

    var scenario = gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: { trigger: section, start: 'top top', end: 'bottom bottom', scrub: 0.5 },
      onUpdate: function () { avancerHorloge(scenario.progress()); },
    });

    scenario
      /* Le ciel : nuit, indigo violacé, indigo, ciel du matin, lin. */
      .to(ciel('crepuscule'), { opacity: 1, duration: 0.26 }, 0.06)
      .to(ciel('aube'), { opacity: 1, duration: 0.24 }, 0.32)
      .to(ciel('reveil'), { opacity: 1, duration: 0.14 }, 0.6)
      .to(ciel('lin'), { opacity: 1, duration: 0.16 }, 0.74)
      .to(horloge, { color: couleur('--lin-50'), duration: 0.14 }, 0.2)
      .to(horloge, { color: couleur('--nuit-950'), duration: 0.04 }, 0.64)
      /* La lumière du diffuseur gagne la pièce, puis se fond dans le jour. */
      .fromTo(q('.recit-lueur'), { scale: 0.2, opacity: 0 }, { scale: 1, opacity: 0.55, duration: 0.56 }, 0.08)
      .to(q('.recit-lueur'), { scale: 1.5, opacity: 0, duration: 0.22 }, 0.7)
      /* Pied de scène assombri le temps de la phrase de l'aube (texte clair, halo au plus fort). */
      .to(q('.recit-voile'), { opacity: 1, duration: 0.08 }, 0.28)
      .to(q('.recit-voile'), { opacity: 0, duration: 0.08 }, 0.62)
      /* Le produit s'éclaire : chaque état se pose sur le précédent, qui s'efface ensuite. */
      .fromTo(q('.recit-objet'), { yPercent: 3, scale: 0.94 }, { yPercent: 0, scale: 1, duration: 0.8 }, 0)
      .to(objet('aube'), { opacity: 1, duration: 0.2 }, 0.2)
      .to(objet('nuit'), { opacity: 0, duration: 0.05 }, 0.4)
      .to(objet('reveil'), { opacity: 1, duration: 0.2 }, 0.56)
      .to(objet('aube'), { opacity: 0, duration: 0.05 }, 0.76)
      /* Trois phrases, chacune sur le fond qui lui garantit son contraste. */
      .to(texte('nuit'), { opacity: 0, y: -24, duration: 0.07 }, 0.25)
      .fromTo(texte('aube'), { opacity: 0, y: 32 }, { opacity: 1, y: 0, duration: 0.09 }, 0.35)
      .to(texte('aube'), { opacity: 0, y: -24, duration: 0.07 }, 0.54)
      .fromTo(texte('reveil'), { opacity: 0, y: 32 }, { opacity: 1, y: 0, duration: 0.09 }, 0.74)
      /* Tenue finale sur le lin, avant la suite de la page. */
      .set({}, {}, 1);
  }

  /**
   * Horloge à rouleaux : 6 h 30 à 7 h 00 entre 4 % et 78 % de la course. Chaque case glisse d'un
   * chiffre à l'autre (transition CSS --dur-rouleau, interruptible) ; la bande des unités contient deux
   * fois 0–9 pour tourner toujours dans le sens du temps. L'affichage du socle suit la même minute.
   */
  function horlogeARouleaux(gsap, section) {
    var DEBUT = 390;
    var FIN = 420;
    var bande = function (nom) { return section.querySelector('[data-rouleau="' + nom + '"] .recit-bande'); };
    var heures = bande('heure');
    var dizaines = bande('dizaine');
    var unites = bande('unite');
    var affichages = section.querySelectorAll('[data-afficheur]');
    var minuteCourante = DEBUT;
    var indexUnites = 0;

    var placer = function (element, index, instantane) {
      if (!element) return;
      if (instantane) {
        element.style.transition = 'none';
        element.style.transform = 'translateY(' + -index + 'em)';
        void element.offsetHeight;
        element.style.transition = '';
        return;
      }
      element.style.transform = 'translateY(' + -index + 'em)';
    };

    return function (progression) {
      var t = gsap.utils.clamp(0, 1, (progression - 0.04) / 0.74);
      var minute = DEBUT + Math.round(t * (FIN - DEBUT));
      if (minute === minuteCourante) return;
      var enAvant = minute > minuteCourante;
      minuteCourante = minute;

      var h = Math.floor(minute / 60);
      var m = minute % 60;
      placer(heures, h - 6);
      placer(dizaines, h === 7 ? 3 : Math.floor(m / 10) - 3);

      /* En avant, on part de la première dizaine ; en arrière, de la seconde. */
      var chiffre = m % 10;
      var depart = indexUnites;
      if (enAvant && depart >= 10) depart -= 10;
      if (!enAvant && depart < 10) depart += 10;
      if (depart !== indexUnites) placer(unites, depart, true);
      indexUnites = enAvant ? (chiffre >= depart ? chiffre : chiffre + 10) : (chiffre <= depart - 10 ? chiffre + 10 : chiffre);
      placer(unites, indexUnites);

      var libelle = formatHorloge(minute);
      for (var i = 0; i < affichages.length; i++) ecrireAfficheur(affichages[i], libelle);
    };
  }

  /** Dérive horizontale d'un chiffre géant pendant sa traversée de l'écran ([data-derive] = amplitude en %). */
  function deriver(gsap, element) {
    var amplitude = Number(element.dataset.derive) || 6;
    gsap.fromTo(
      element,
      { xPercent: amplitude },
      {
        xPercent: -amplitude,
        ease: 'none',
        scrollTrigger: { trigger: element, start: 'top bottom', end: 'bottom top', scrub: true },
      }
    );
  }

  function demarrerMouvement() {
    if (!document.getElementById('recit') && !$('[data-derive]')) return;
    var sansReduction = window.matchMedia('(prefers-reduced-motion: no-preference)');
    var charger = function () {
      chargerMoteur()
        .then(function () {
          if (arreterScenes) arreterScenes();
          arreterScenes = lancerScenes();
        })
        .catch(function () {
          /* Sans moteur, le récit garde ses bandes fixes : rien à rattraper. */
        });
    };
    var programmer = function () {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(charger, { timeout: 2000 });
      else window.setTimeout(charger, 300);
    };
    if (sansReduction.matches) programmer();
    else {
      sansReduction.addEventListener('change', function auChangement() {
        if (!sansReduction.matches) return;
        sansReduction.removeEventListener('change', auChangement);
        programmer();
      });
    }
  }

  /* ------------------------------------------------------------------------
     Démarrage, et nouvel affichage d'une section dans l'éditeur de thème
     ------------------------------------------------------------------------ */

  function initDans(dans) {
    $$('[data-moments]', dans).forEach(initMoments);
    $$('[data-simulateur]', dans).forEach(initSimulateur);
    $$('[data-galerie]', dans).forEach(initGalerie);
    initRevelations(dans);
  }

  initDans(document);
  synchroniserVariante();
  initEnTete();

  /* Après l'événement load, pour ne rien disputer au visuel du hero (LCP) : visuels du récit
     ([data-charge] sur <html>), puis, au premier temps libre, le moteur du récit. */
  function apresChargement() {
    racine.dataset.charge = '';
    demarrerMouvement();
  }
  if (document.readyState === 'complete') apresChargement();
  else window.addEventListener('load', apresChargement, { once: true });

  document.addEventListener('shopify:section:load', function (evenement) {
    initDans(evenement.target);
    if (estFicheDuProduit()) appliquerVariante();
    if ($('#recit, [data-derive]', evenement.target) && moteur) {
      if (arreterScenes) arreterScenes();
      arreterScenes = lancerScenes();
    }
  });
})();
